export function isTesting () {
  return process.env.VUE_APP_ENV === 'testing'
}

export function isZavaBrand () {
  return process.env.VUE_APP_BRAND === 'zava'
}

export function isSuperdrugBrand () {
  return process.env.VUE_APP_BRAND === 'superdrug'
}

export function isAsdaBrand () {
  return process.env.VUE_APP_BRAND === 'asda'
}

export function thirdPartyBrand () {
  let thirdPartyBrand = false
  if (isSuperdrugBrand()) {
    thirdPartyBrand = 'sd'
  }

  return thirdPartyBrand
}
